import { AIThread, threadBaseOps } from '@basehub/data/replicache/index'
import { ReadTransaction, WriteTransaction } from 'replicache'
import { WithServerSecret } from '../../../tx/spec'
import { hasAccessOrThrow } from '../../team-space/team/auth'
import { ensureBaseHubTransaction } from '@basehub/data/replicache/tx/iso'

async function getThreadsByIdPair(
  tx: ReadTransaction,
  { ...data }: WithServerSecret<{ blockId: string; userId: string }>
) {
  ensureBaseHubTransaction(tx)
  hasAccessOrThrow({
    serverOnly: tx.serverOnly,
    clientOnly: tx.clientOnly,
    serverSecret: tx.serverSecret,
    allowedRoles: ['owner', 'editor', 'member'],
    guestAccess: 'branch-author',
  })
  const threads = await threadBaseOps.list(tx)
  return (
    threads
      .filter(
        ({ blockId, userId }) =>
          data.blockId === blockId && data.userId === userId
      )
      .sort((a, b) => {
        return a.createdAt < b.createdAt ? 1 : -1
      }) ?? null
  )
}

async function createThread(
  tx: WriteTransaction,
  { ...data }: WithServerSecret<AIThread>
) {
  ensureBaseHubTransaction(tx)
  hasAccessOrThrow({
    serverOnly: tx.serverOnly,
    clientOnly: tx.clientOnly,
    serverSecret: tx.serverSecret,
    allowedRoles: ['owner', 'editor', 'member'],
    guestAccess: 'branch-author',
  })

  return threadBaseOps.put(tx, data)
}

async function deleteThread(
  tx: WriteTransaction,
  { id }: WithServerSecret<{ id: string }>
) {
  ensureBaseHubTransaction(tx)
  hasAccessOrThrow({
    serverOnly: tx.serverOnly,
    clientOnly: tx.clientOnly,
    serverSecret: tx.serverSecret,
    allowedRoles: ['owner', 'editor', 'member'],
    guestAccess: 'branch-author',
  })

  return threadBaseOps.delete(tx, id)
}

async function updateThread(
  tx: WriteTransaction,
  { ...data }: WithServerSecret<Partial<AIThread> & { id: string }>
) {
  ensureBaseHubTransaction(tx)
  hasAccessOrThrow({
    serverOnly: tx.serverOnly,
    clientOnly: tx.clientOnly,
    serverSecret: tx.serverSecret,
    allowedRoles: ['owner', 'editor', 'member'],
    guestAccess: 'branch-author',
  })

  return threadBaseOps.update(tx, data)
}

export const threadMutators = {
  createThread,
  listThreads: threadBaseOps.list,
  updateThread,
  deleteThread,
  getThreadsByIdPair,
}
